<template>
    <b-container fluid>
        <b-row row>
            <b-col cols="12">
                <app-sub-title text="Puntos de control"></app-sub-title>
                <small class="text-muted">Pueden ser configurados después</small>
            </b-col>
        </b-row>
        <b-row row wrap align-v="center">
            <b-col cols="12" md="5">
                <app-form-text-input
                    ref="controlPointName"
                    placeholder="Nombre"
                    v-model="point.name"
                    id="control-point-name"
                ></app-form-text-input>
            </b-col>
            <b-col cols="12" md="5">
                <app-form-text-input placeholder="Descripción" v-model="point.description"></app-form-text-input>
            </b-col>
            <b-col cols="12" md="2">
                <b-btn variant="primary" size="sm" @click="addPoint"><i class="fa fa-plus"></i></b-btn>
            </b-col>
        </b-row>
        <div class="points">
            <b-row row wrap v-for="(point, index) in points" :key="index" align-v="center">
                <b-col cols="12" md="1">{{ index + 1 }}</b-col>
                <b-col cols="12" md="4">{{ point.name }}</b-col>
                <b-col cols="12" md="4">{{ point.description | elipsis(10) }}</b-col>
                <b-col cols="12" md="2">
                    <b-btn variant="danger" size="sm" @click="removePoint(index)"><i class="fa fa-trash"></i></b-btn>
                </b-col>
            </b-row>
        </div>
    </b-container>
</template>
<script>
export default {
    data: () => ({
        point: {
            name: '',
            description: ''
        },
        points: []
    }),
    methods: {
        addPoint() {
            if(!this.point.name) return;
            const vm = this;

            if(navigator.geolocation) {
                const coords = navigator.geolocation.getCurrentPosition(position => {
                    vm.addPointNext(position.coords.latitude, position.coords.longitude);
                });
            }
        },
        addPointNext(latitude, longitude) {
            this.points.push({...this.point, latitude, longitude});
            Object.keys(this.point).map(key => this.point[key] = '');
            this.update();
            this.$refs.controlPointName.focus();
        },
        removePoint(index) {
            this.points.splice(index, 1);
            this.update();
        },
        update() {
            this.$emit('input', this.points);
            this.$emit('change', this.points);
        }
    }
}
</script>
